import { render, staticRenderFns } from "./excellentcases_detail.vue?vue&type=template&id=ff8d39a2&scoped=true&"
import script from "./excellentcases_detail.vue?vue&type=script&lang=js&"
export * from "./excellentcases_detail.vue?vue&type=script&lang=js&"
import style0 from "./excellentcases_detail.vue?vue&type=style&index=0&id=ff8d39a2&scoped=scoped&lang=scss&"
import style1 from "./excellentcases_detail.vue?vue&type=style&index=1&id=ff8d39a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8d39a2",
  null
  
)

export default component.exports